type IBreadcrumbRoute = {
  [path: string]: {
    href: string;
  };
};

export const BreadcrumbsMapper: IBreadcrumbRoute = {
  blogs: {
    href: "/blogs",
  },
  services: {
    href: "/services",
  },
  teams: {
    href: "/teams",
  },
};
